import { createSelector } from 'reselect'

import { LocationFilterState } from '@/components/shared/filters/location-filter/types'

const baseSelector = (state: LocationFilterState) => state
export const resultsSelector = createSelector(baseSelector, (state) => state.data || [])
export const tokenSelector = createSelector(baseSelector, (state) => state.token)

export const querySelector = createSelector(baseSelector, (state) => state.query)
